import Card, { CardHeader, CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import { Tabs, TabList, Tab, TabPanel } from '@/components/ui/Tabs';

export default function AdminSettingsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Settings</h1>
        <p className="text-slate-500 mt-1">Configure system settings and preferences</p>
      </div>

      <Tabs defaultTab="general">
        <TabList>
          <Tab value="general">General</Tab>
          <Tab value="api">API Keys</Tab>
          <Tab value="webhooks">Webhooks</Tab>
          <Tab value="features">Feature Flags</Tab>
        </TabList>

        <TabPanel value="general" className="mt-6">
          <Card>
            <CardHeader title="General Settings" />
            <CardBody className="space-y-4">
              <Input label="Application Name" defaultValue="Kampus Unified" />
              <Input label="Default Locale" defaultValue="fr-CA" />
              <Input label="Support Email" defaultValue="support@kampus.com" />
              <div className="pt-4">
                <Button>Save Changes</Button>
              </div>
            </CardBody>
          </Card>
        </TabPanel>

        <TabPanel value="api" className="mt-6">
          <Card>
            <CardHeader title="API Keys" subtitle="Manage API keys for service integrations" />
            <CardBody className="space-y-4">
              <div className="p-4 bg-slate-50 rounded-xl">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">TTS Worker API Key</p>
                    <p className="text-sm text-slate-500 font-mono">sk-tts-****-****-****-abc123</p>
                  </div>
                  <Button variant="outline" size="sm">Regenerate</Button>
                </div>
              </div>
              <div className="p-4 bg-slate-50 rounded-xl">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">Distribution Worker API Key</p>
                    <p className="text-sm text-slate-500 font-mono">sk-dist-****-****-****-xyz789</p>
                  </div>
                  <Button variant="outline" size="sm">Regenerate</Button>
                </div>
              </div>
              <Button>Add New API Key</Button>
            </CardBody>
          </Card>
        </TabPanel>

        <TabPanel value="webhooks" className="mt-6">
          <Card>
            <CardHeader title="Webhooks" subtitle="Configure webhook endpoints for events" />
            <CardBody className="space-y-4">
              <Input label="Job Completion Webhook" placeholder="https://your-server.com/webhook/job-complete" />
              <Input label="Distribution Event Webhook" placeholder="https://your-server.com/webhook/distribution" />
              <div className="pt-4">
                <Button>Save Webhooks</Button>
              </div>
            </CardBody>
          </Card>
        </TabPanel>

        <TabPanel value="features" className="mt-6">
          <Card>
            <CardHeader title="Feature Flags" subtitle="Enable or disable experimental features" />
            <CardBody className="space-y-4">
              {[
                { name: 'New Dashboard', description: 'Enable the redesigned dashboard', enabled: true },
                { name: 'Batch Processing', description: 'Process multiple files at once', enabled: true },
                { name: 'AI Enhancements', description: 'Use AI for chapter detection', enabled: false },
                { name: 'Beta Features', description: 'Access beta features early', enabled: false },
              ].map((flag) => (
                <div key={flag.name} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div>
                    <p className="font-medium">{flag.name}</p>
                    <p className="text-sm text-slate-500">{flag.description}</p>
                  </div>
                  <button
                    className={`w-12 h-6 rounded-full transition-colors ${
                      flag.enabled ? 'bg-primary-400' : 'bg-slate-300'
                    }`}
                  >
                    <div
                      className={`w-5 h-5 rounded-full bg-white shadow transition-transform ${
                        flag.enabled ? 'translate-x-6' : 'translate-x-0.5'
                      }`}
                    />
                  </button>
                </div>
              ))}
            </CardBody>
          </Card>
        </TabPanel>
      </Tabs>
    </div>
  );
}

